import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import EnvironmentSelect from '../../common/formElements/EnvironmentSelect';
import { FileUpload } from '../../common/formElements/FileUpload';
import UploadJonPreview from './item/import/UploadJsonPreview';
import { toast } from 'react-toastify';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import { excludedFields } from '../common/FieldTypes';

export class ImportDataFromJson extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const result = await actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    const { collections } = this.props;
    const { fields } = collections.selectedCollection;
    this.setState({ selectedCollection: collections.selectedCollection });
    await this.extractFieldNames(fields);
  }
  state = {
    jsondData: '',
    selectedCollection: null,
    jsonContent: [],
    jsonHeaders: [],
  };
  reloadItemForm = () => {
    const { refreshItemForm } = this.props;
    if (refreshItemForm) {
      refreshItemForm();
    }
  };
  extractFieldNames = (array) => {
    const result = {};
    array.forEach((item) => {
      if (!excludedFields.includes(item.fieldName)) {
        result[item.fieldName] = `Replace your ${item.fieldName} here`;
      }
    });
    const final = JSON.stringify([result, result, result]);
    this.setState({ jsondData: final });
    return;
  };

  cleanJsonContent = (dataArray) => {
    return dataArray.map((item) => {
      const cleaned = {};
      for (const key in item) {
        if (!excludedFields.includes(key)) {
          cleaned[key] = item[key];
        }
      }
      return cleaned;
    });
  };

  handleSubmit = async () => {
    const { match, actions, history } = this.props;
    const { projectId, version, collectionId } = match.params;
    const { jsonContent, selectedCollection } = this.state;
    const { collectionName } = selectedCollection;
    const cleanedContent = this.cleanJsonContent(jsonContent);
    await actions.importItemsFromJson({
      projectId,
      version,
      collectionName,
      formData: cleanedContent,
    });

    history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionName}`,
    );
  };

  handleCancel = () => {
    const { collections, match, history } = this.props;
    const { selectedCollection } = collections;
    const { collectionName } = selectedCollection;
    const { projectId, collectionId, version } = match.params;
    history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionName}`,
    );
  };
  uploadFile = (file) => {
    if (file && file.type === 'application/json') {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const content = await JSON.parse(e.target.result);
          const checkContent = Array.isArray(content);
          if (checkContent === false) {
            toast.error('Please Upload Correct JSON File.');
          }
          this.setState({ jsonContent: content });
          const keysArray = Object.keys(content[0]);
          this.setState({ jsonHeaders: keysArray });
        } catch (error) {
          toast.error('Error in parsing this JSON .');
          return;
        }
      };
      reader.readAsText(file);
    } else {
    }
  };
  downloadJsonData = () => {
    const { selectedCollection, jsondData } = this.state;
    const { collectionName } = selectedCollection;
    const filename = `${collectionName}`;
    const blob = new Blob([JSON.stringify(JSON.parse(jsondData), null, 2)], {
      type: 'application/json',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename + '.json';
    link.click();
  };
  render() {
    const { collections, match, importActions, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const { importItemsFromJsonPending, selectedCollection } = collections;
    const { jsonContent, jsonHeaders } = this.state;
    return (
      <CommonPageComponent>
        <CollectionHeaderNav
          label="JSON"
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          uploadHeaders
        />
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="card">
            <div
              className="card-header card-header-icon"
              data-background-color="drapcode-dark-blue"
            >
              <i className={`wb webconnect-database`}></i>
            </div>
            <div className="card-title-header pt-3 d-flex justify-content-evenly">
              <div>
                <h4 className="card-title">Import Items From JSON</h4>
              </div>
              <div className="col"> </div>
              <div className="card-title text-center">
                <button className="btn btn-primary btn-md mr-2" onClick={this.downloadJsonData}>
                  <i className="wb webconnect-download"></i> Download JSON Template
                </button>
              </div>
              <div className="col-3 mt-8">
                <EnvironmentSelect
                  projectId={projectId}
                  version={version}
                  refreshMethod={() => this.reloadItemForm()}
                />
              </div>
            </div>
            <div className="row mx-auto">
              <div className="col-12">
                <div className="row mx-auto mb-3">
                  {jsonContent.length > 0 && jsonHeaders.length > 0 ? (
                    <div className="card-body">
                      <UploadJonPreview csvHeader={jsonHeaders} csvData={jsonContent} />
                    </div>
                  ) : (
                    <FileUpload
                      projectId={projectId}
                      maxFiles={1}
                      accept={'.json'}
                      maxSizeBytes="20971520"
                      fileIcon="customTheme"
                      uploadFile={this.uploadFile}
                      defaultUpload={false}
                    />
                  )}
                </div>
              </div>
              <div className="text-center flex-end">
                <button
                  type="button"
                  className="btn btn-outline btn-md  "
                  onClick={this.handleCancel}
                  title="Cancel JSON Import"
                >
                  <i className="wb webconnect-times"> </i> Cancel
                </button>
                &nbsp;
                {jsonContent.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-theme-submit btn-md"
                    onClick={this.handleSubmit}
                    title="Import JSON Content"
                  >
                    <i className="wb webconnect-upload"></i>
                    &nbsp;Upload
                    <CustomLoader loading={importItemsFromJsonPending} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportDataFromJson);
